export const PERMISSIONS = {
  PERMISSION_VIEWER: "PERMISSION_VIEWER",
  PERMISSION_EDITOR: "PERMISSION_EDITOR",
  SYSTEM_DEFAULT_VIEWER: "SYSTEM_DEFAULT_VIEWER",
  SYSTEM_DEFAULT_EDITOR: "SYSTEM_DEFAULT_EDITOR",
  SUPPLIER_VIEWER: "SUPPLIER_VIEWER",
  SUPPLIER_EDITOR: "SUPPLIER_EDITOR",
  BOOKING_SUPPLIER_COST_VIEWER: "BOOKING_SUPPLIER_COST_VIEWER",
  BOOKING_SUPPLIER_COST_EDITOR: "BOOKING_SUPPLIER_COST_EDITOR",
  INVOICE_VIEWER: "INVOICE_VIEWER",
  INVOICE_EDITOR: "INVOICE_EDITOR",
  WORKFLOW_VIEWER: "WORKFLOW_VIEWER",
  WORKFLOW_EDITOR: "WORKFLOW_EDITOR",
  EXCEPTION_REPORT_VIEWER: "EXCEPTION_REPORT_VIEWER",
  EXCEPTION_REPORT_EDITOR: "EXCEPTION_REPORT_EDITOR",
  DASHBOARD_VIEWER: "DASHBOARD_VIEWER",
  DASHBOARD_EDITOR: "DASHBOARD_EDITOR",
  FINANCIAL_REPORT_VIEWER: "FINANCIAL_REPORT_VIEWER",
  FINANCIAL_REPORT_EDITOR: "FINANCIAL_REPORT_EDITOR",
  MASTER_DATA_VIEWER: "MASTER_DATA_VIEWER",
  MASTER_DATA_EDITOR: "MASTER_DATA_EDITOR",
  SYSTEM_REPORT_ADMIN_EDITOR: "SYSTEM_REPORT_ADMIN_EDITOR",
} as const;